import { Col, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import { getFullContactName } from 'Utilities'

import type { PortalReturnLabelDeviceIdentificationProps } from './PortalReturnLabelModal.types'
import { PortalReturnLabelModalGhostXButton } from './PortalReturnLabelModalGhostXButton'

export const PortalReturnLabelDeviceIdentification = (
  props: PortalReturnLabelDeviceIdentificationProps,
) => {
  const { onRemove, returnCase } = props
  const intl = useIntl()
  const deviceDefinition = returnCase.stocklistItem?.deviceDefinition
  const employeeName = returnCase.employee?.contact
    ? getFullContactName(returnCase.employee.contact)
    : '-'

  return (
    <div className="mb-4 p-4 border rounded-4">
      <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
        <div className="PortalReturnLabelModal-deviceTitle text-line-clamp">
          {deviceDefinition?.name || '-'}
        </div>

        {onRemove && (
          <PortalReturnLabelModalGhostXButton
            ariaLabel={intl.formatMessage({
              id: 'PublicRequestReturnLabel_deviceIdentifier_removeDevice',
            })}
            onClick={onRemove}
          />
        )}
      </div>

      <Row className="gy-2">
        <Col md={6} xs={12}>
          <span className="PortalReturnLabelModal-fieldLabel d-block">
            <FormattedMessage id="IMEI" />
          </span>
          <p className="m-0 text-break fw-600">
            {returnCase.stocklistItem?.imei || '-'}
          </p>
        </Col>

        <Col md={6} xs={12}>
          <span className="PortalReturnLabelModal-fieldLabel d-block">
            <FormattedMessage id="ReturnDetails_serial_number" />
          </span>
          <p className="m-0 text-break fw-600">
            {returnCase.stocklistItem?.serialNumber || '-'}
          </p>
        </Col>

        <Col md={6} xs={12}>
          <span className="PortalReturnLabelModal-fieldLabel d-block">
            <FormattedMessage id="IMEI2" />
          </span>
          <p className="m-0 text-break fw-600">
            {returnCase.stocklistItem?.imei2 || '-'}
          </p>
        </Col>

        <Col md={6} xs={12}>
          <span className="PortalReturnLabelModal-fieldLabel d-block">
            <FormattedMessage id="Employee" />
          </span>
          <p className="m-0 text-break fw-600">{employeeName}</p>
        </Col>
      </Row>
    </div>
  )
}
